import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <div className="hero-section-1 relative flex flex-col items-start">
      <motion.div
        animate={{ scale: [0, 0.7] }}
        transition={{
          ease: 'linear',
          duration: 1,
          x: { duration: 1 },
        }}
      >
        <h1 className="text-center text-7xl text-white md:text-9xl lg:text-9xl">
          “Information is the <span className="text-[#46C6ED]"> resolution </span> of uncertainty”
        </h1>
      </motion.div>
    </div>
  );
};

export default Hero;
